import styles from './StageStopModal.module.css';

import { address_server_short, PUBLIC_ASSETS } from 'config';
import Icon from 'ui/Icon';
import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import FormTextField from 'ui/formItems/FormTextField';

const StopObject = ({ object, index }) => {
  const { setValue } = useFormContext();

  useEffect(() => {
    setValue(`objects.[${index}].id`, object.id);
    setValue(`objects.[${index}].type`, object.type);
  }, []);

  return (
    <div key={object.id} className={styles.objectsContainer}>
      <div className={styles.wrapperIcon}>
        <Icon width={44} height={44} src={address_server_short + PUBLIC_ASSETS + object.image} />
        <div>{object.name}</div>
      </div>

      <FormTextField
        name={`objects.[${index}].value.volume`}
        hideErrorBlock
        className={styles.input}
        label="Количество:"
        type={'number'}
        step={0.1}
      />

      <span>{object && object.unit_name}</span>
    </div>
  );
};

export default StopObject;
